module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABIklEQVR4AWOgD6iIQ0HlSIxyVClMDVzV0VyVsX6TXQOmuAIZXDXReDWUJqq1Buu0+Uk0REs2RGu3+au3BQMFcWgoSzDu8het8xdsyl91+cyay2eFm/JFav1NuvyAUtg0lMdzVoUJ1sToTaz9/ffv33//DCbVAbmcVaFAKWwaSiJd53RvvX5x8bmj7759+fD9K5Cx7cZF97k9QClsGorCQ5ZM/v33z////7/9+vXt108gA2hV2LIpQClsGkqjVbpKWvZuXHXpZNm2FaXbVgAZrfs2qnaXAKWw+iGWvz7Nf2F/weYlKWvmJq+ZW7B5qf+iCQL1aUApHMFaFs1eneg0u71qx+qqnaudZ3dwVCcCBfFFHMiw4giG0iggAjIgZiPQoAQAyZS0OnH+e2YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MO.png
// module id = 1211
// module chunks = 0